import React from 'react';
import {
  UserOutlined,
  LockOutlined,
  PoweroffOutlined,
} from '@ant-design/icons';

const constants = {
  URL_EXPORT_EXCEL: 'http://10.4.72.243:9000',
  URL_EXPORT_EXCEL_MINIO: 'https://merchant.vietinbank.vn',

  TIMEOUT_REQUEST: 60000,
  EXPIRE_TIME_TOKEN: 30 * 60 * 1000,
  EXPIRE_TIME_REFRESH_TOKEN: 60 * 60 * 1000,

  FORMAT_DATE_TIME: 'DD/MM/YYYY HH:mm:ss',

  PROFILE_MENU_ITEMS: [
    {
      name: 'Thông tin đơn vị kinh doanh',
      icon: <UserOutlined />,
      url: '/merchant-profile',
    },
    {
      name: 'Đổi mật khẩu',
      icon: <LockOutlined />,
      url: '/account-management/change-password',
    },
    {
      name: 'Thoát',
      icon: <PoweroffOutlined />,
      function: 'logout',
    },
  ],

  VIETINBANK_CODE: '970489',
  VNPAY_CODE: '908405',

  CODE_SUCCESS: '00',
  CODE_CHANGE_PASSWORD_FAIL: '37',
  CODE_TOKEN_FAIL: '-2',
  CODE_LOGIN_FAIL: '50',
  CODE_UNAUTHORIZE: '-1',
  CODE_TOKEN_HASH_EXPIRE: '-3',

  QRCODE_PAYMENT_TYPE: [
    { code: 0, value: 'Nội địa' },
    { code: 1, value: 'Quốc tế' },
  ],

  QRCODE_PAYMENT_TYPE_QR: [
    { code: '1', value: 'QR Quốc tế' },
    { code: '2', value: 'QR Nội địa' },
  ],

};

export default constants;
